module.exports = __webpack_public_path__ + "img/agro.a5c2ec61.svg";